import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { AddressClient } from 'src/WebApiController';

const MAINE_STATE_NAMES_DEFAULT: string[] = ['MAINE', 'ME'];

export function useMaineStateNames() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();

  const query = useQuery({
    queryKey: [
      'getMaineStateProvinceNames',
      activeAccountWebClientConfig.activeAccountId,
    ],
    queryFn: async () => {
      if (activeAccountWebClientConfig.activeAccountId == null) {
        return null;
      }
      return await new AddressClient(
        activeAccountWebClientConfig
      ).getMaineStateProvinceNames();
    },

    enabled: activeAccountWebClientConfig.activeAccountId != null,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    meta: {
      persist: true,
      onError: (error: ErrorTypes) => {
        showErrorDialog('AddressClient.getMaineStateProvinceNames', error);
      },
    },
  });

  return query.data || MAINE_STATE_NAMES_DEFAULT;
}
